import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_MOU_LIST,
    getMouListFail,
    getMouListSuccess
} from '../action/getMouListAction'

// api 
import getMouListApi from '../api/getMouListApi'

export function* getMouListSaga(action) {
    try {
        const response = yield call(() => getMouListApi(action.params))
        if (response.data.status === 1) {
            yield put(getMouListSuccess(response, action))
        } else {
            yield put(getMouListFail(response, action))
        }
    }
    catch (e) {
        yield put(getMouListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_MOU_LIST, getMouListSaga)
}